import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Paper,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';
import { int } from 'aws-sdk/clients/datapipeline';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useSelector } from '../../store/store';
import { v2apiBlob } from '../../api/axios';
import { useState } from 'react';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';

dayjs.extend(timezone);
dayjs.extend(utc);

interface Props {
  id: string;
  recordId: string;

  message: string | null;
  incomingDate: string;
  duration: int;
  fromNumber: string;
  handleDelete: (id: string) => void;
}

function Record(props: Props) {
  const {
    id,
    recordId,
    message,
    incomingDate,
    duration,
    fromNumber,
    handleDelete,
  } = props;
  const formattedIncomingDate = dayjs(incomingDate)
    .tz('Asia/Tokyo')
    .format('YY/MM/DD HH:mm:ss');
  const formattedDuration = duration ? `（${duration}秒）` : '';
  const [expanded, setExpanded] = React.useState<string | false>(false);

  // ストアからユーザー情報を取得
  const user = useSelector((state) => state.loginUser.user);

  // アコーディオンのチェンジイベント
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  // ボタンクリック時
  const onButtonClick = () => {
    handleDelete(id);
  };

  // 再生ボタンが押された
  const [disablePlay, setDisablePlay] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(new Audio());
  const handlePlayRecording = async (e: any) => {
    setDisablePlay(true);

    // 録音データを取得
    const postData = {
      userId: user.id,
      token: user.access_token,
      recordingS3Id: recordId,
    };
    const res = await v2apiBlob.post('/get-record', postData);
    const blobUrl = URL.createObjectURL(
      new Blob([res.data], { type: 'audio/mp3' }),
    );
    const audio = new Audio(blobUrl);
    audio.addEventListener('ended', (e: any) => {
      // 再生が終了したとき
      setDisablePlay(false);
    });
    audio.load();
    audio.play();
    setCurrentAudio(audio);
  };

  // 停止ボタンが押された
  const handleStopRecording = async (e: any) => {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    setDisablePlay(false);
  };

  if (recordId) {
    return (
      <div>
        <Accordion
          expanded={expanded === 'panel'}
          onChange={handleChange('panel')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel-content'
            id='panel-header'
          >
            <PermPhoneMsgIcon color={'primary'} />
            <Typography>{`${fromNumber}`}</Typography>
            <Typography
              color={'gray'}
            >{` - [${formattedIncomingDate}]`}</Typography>
            <Typography>{`${formattedDuration}`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={0} alignItems='center'>
              <Grid item>
                {disablePlay ? (
                  <IconButton onClick={handleStopRecording}>
                    <StopCircleOutlinedIcon />
                  </IconButton>
                ) : (
                  <IconButton onClick={handlePlayRecording}>
                    <PlayCircleOutlineIcon />
                  </IconButton>
                )}
              </Grid>
              <Grid item>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                  <Typography>
                    {message === ''
                      ? '（音声は録音されていませんでした）'
                      : message}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 1,
                m: 1,
                bgcolor: 'background.paper',
                borderRadius: 1,
              }}
            >
              <IconButton onClick={onButtonClick}>
                <DeleteForeverIcon fontSize='large' color='error' />
              </IconButton>
            </Box>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  } else {
    return (
      <div>
        <Accordion
          expanded={expanded === 'panel'}
          onChange={handleChange('panel')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel-content'
            id='panel-header'
          >
            <PermPhoneMsgIcon color={'disabled'} />
            <Typography>{`${fromNumber}`}</Typography>
            <Typography
              color={'gray'}
            >{` - [${formattedIncomingDate}]`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                // p: 1,
                // m: 1,
                bgcolor: 'background.paper',
                borderRadius: 1,
              }}
            >
              <IconButton onClick={onButtonClick}>
                <DeleteForeverIcon fontSize='large' color='error' />
              </IconButton>
            </Box>
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
}

export default Record;
